import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CaretUpFilledSvg from "@ant-design/icons-svg/es/asn/CaretUpFilled";
import AntdIcon from "../components/AntdIcon";
var CaretUpFilled = function CaretUpFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretUpFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CaretUpFilled.displayName = 'CaretUpFilled';
}
export default /*#__PURE__*/React.forwardRef(CaretUpFilled);